import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AppLanguage } from '../../types';
import { AuthConsumer } from '../Authentication/AuthProvider';
import { IdaLoginRoleTypes as Roles } from '@ida/ida-login-model';

const DefaultMemberRoles = [
  Roles.IDAMember, 
  Roles.IDAStudyMember, 
  Roles.DDLMember, 
  Roles.DDLStudyMember];

interface PrivateRouteProps extends RouteProps {
  roles?: string[];
  language?: AppLanguage;
}

export default function PrivateRoute({
  path,
  component,
  roles = DefaultMemberRoles,
  language,
}: PrivateRouteProps) {
  return (
    <AuthConsumer>
      {({ isAuthenticated, signinRedirect, hasRole }): JSX.Element => {
        if (!!component && isAuthenticated()) {
          // Routes don't need role control. ex. Logout.
          if (roles.length === 0) {
            return <Route path={path} component={component} />;
          } else {
            return hasRole(roles) ? (
              <Route path={path} component={component} />
            ) : (
              <Redirect
                to={{
                  pathname: language === AppLanguage.English ? `/en/no-access` : `/ingen-adgang`,
                }}
              />
            );
          }
        }
        signinRedirect();
        return <></>;
      }}
    </AuthConsumer>
  );
}
